/* eslint-disable import/no-relative-parent-imports */
import { Col, Row } from 'antd';
import cn from 'classnames';
import { FieldInputProps, FieldMetaProps } from 'formik';
import { Eye, EyeOff } from 'lucide-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button/Button';
import CustomTextField from '~/components/fields/CustomTextField/CustomTextField';
import { AvailableBank } from '~/entities/schemas/availableBank';
import { PaymentService } from '~/services/PaymentService';
import { formatdateOfBirth } from '~/utils/handle-input-events';

import styles from '../../fields/CustomTextField/CustomTextField.module.scss';
import './StylesBank.scss';
export interface BankPaymentMethodFormProps {
  getFieldProps: (name: string) => FieldInputProps<any>;
  getFieldMeta: (name: string) => FieldMetaProps<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  gettingBank: boolean;
  availableBank: AvailableBank[] | null;
  setSelectedAvailableBank: (bank: AvailableBank) => void;
  selectedAvailableBank: AvailableBank | any;
  showMessageInit: boolean;
  showChoiceAccount: boolean;
  setShowChoiceAccount: (showChoiceAccount: boolean) => void;
  setShowButtonPay: (value: boolean) => void;
}

const BankPaymentMethodForm: React.FC<BankPaymentMethodFormProps> = ({
  getFieldMeta,
  getFieldProps,
  handleChange,
  gettingBank,
  availableBank,
  setSelectedAvailableBank,
  selectedAvailableBank,
  showMessageInit,
  showChoiceAccount,
  setShowChoiceAccount,
  setShowButtonPay,
}) => {
  const [passwordFieldType, setPasswordFieldType] = useState<'password' | 'text'>('password');
  const [loading, setLoading] = useState<boolean>(false);
  const [showMessageErrorAuth, setShowMessageErrorAuth] = useState<boolean>(false);
  const [showMessageSuccessAuth, setShowMessageSuccessAuth] = useState<boolean>(false);
  const { t } = useTranslation();
  const handleSelectBank = useCallback(
    (e: React.ChangeEvent<any>) => {
      const selectedBank = availableBank?.find(bank => bank.name === e.target.value);
      if (selectedBank) {
        setSelectedAvailableBank(selectedBank);
        limitAccountNumberHandler(selectedBank);
      }
    },
    [availableBank, setSelectedAvailableBank],
  );

  const togglePasswordField = () => setPasswordFieldType(passwordFieldType === 'password' ? 'text' : 'password');

  const [limitAccountNumber, setLimitAccountNumber] = useState<number>(0);
  const limitAccountNumberHandler = useCallback(
    (param: AvailableBank) => {
      setLimitAccountNumber(param.longeurMaxAccount ? param.longeurMaxAccount : limitAccountNumber);
      localStorage.setItem(
        'limitAccountNumber',
        JSON.stringify(param.longeurMaxAccount ? param.longeurMaxAccount : limitAccountNumber),
      );
      // console.log(param.longeurMaxAccount, 'param');
      // console.log(limitAccountNumber, 'limitAccountNumber');
    },
    [limitAccountNumber, setLimitAccountNumber],
  );
  const [accountUsername, setAccountUsername] = useState<string>('');
  const handleBankUsername = (e: React.FormEvent<HTMLInputElement>) => {
    const inputElement = e.target as HTMLInputElement;
    setAccountUsername(inputElement.value);
    console.log(inputElement.value, 'inputElement.value');
  };

  const [accountPassword, setAccountPassword] = useState<string>('');
  const handleBankPassword = (e: React.FormEvent<HTMLInputElement>) => {
    const inputElement = e.target as HTMLInputElement;
    setAccountPassword(inputElement.value);
  };

  const verifUserOBDX = async () => {
    if (!accountUsername || !accountPassword || !selectedAvailableBank?.countrycode) {
      alert(t('bank:requireData'));
      // console.log(accountUsername, 'accountUsername');
      // console.log(selectedAvailableBank?.countrycode, 'selectedAvailableBank');
      // console.log(accountPassword, 'accountPassword');
      return;
    }
    try {
      setLoading(true);
      const body = {
        username: accountUsername,
        password: accountPassword,
        countryCode: selectedAvailableBank?.countrycode,
      };
      const res = await PaymentService.processVerificationUserOBDX(body);
      if (res.status === 'SUCCESS') {
        setLoading(false);
        setShowChoiceAccount(true);
        setShowMessageErrorAuth(false);
        setShowMessageSuccessAuth(true);
        setShowButtonPay(false);
        // console.log(res, 'response');
      } else {
        setLoading(false);
        setShowChoiceAccount(false);
        setShowMessageSuccessAuth(false);
        setShowMessageErrorAuth(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(showChoiceAccount, 'showChoiceAccount');
    console.log(selectedAvailableBank?.countrycode, 'selectedAvailableBank');
  }, [showChoiceAccount, selectedAvailableBank]);

  return (
    <div>
      {showChoiceAccount === false && (
        <>
          <label className="text-field-label" htmlFor="">
            {t('bank:bankName')}
          </label>
        </>
      )}

      {showChoiceAccount === false && (
        <>
          <div className={cn('option-field suffix-icon-wrapper', getFieldMeta('bankName').error)}>
            <select
              className={cn(
                'option-field suffix-icon-wrapper',
                getFieldMeta('bankName').error ? 'select2 option-field suffix-icon-wrapper' : '',
              )}
              name="bankName"
              onChange={e => {
                handleChange(e);
                handleSelectBank(e);
              }}
            >
              {availableBank && availableBank.find(bank => bank.name === selectedAvailableBank?.name)?.name ? (
                <option key={selectedAvailableBank?.name} value={selectedAvailableBank?.name}></option>
              ) : (
                <option value={''}>{t('bank:chooseBank')}</option>
              )}

              {availableBank && availableBank.length > 0 ? (
                availableBank
                  .filter(bank => bank.active === true)
                  .map((bank, index) => (
                    <option key={index} value={bank.name}>
                      {bank.name}
                    </option>
                  ))
              ) : (
                <option>-------</option>
              )}
            </select>
            {selectedAvailableBank?.name && <div className="text-warning">{t('bank:infoFormAfg')}</div>}
            {!!getFieldMeta('bankName').error && <div className="text-danger">{getFieldMeta('bankName').error}</div>}
          </div>
        </>
      )}

      {showChoiceAccount === false && (
        <Row gutter={[30, 30]}>
          <Col span={24} md={12} className="pad">
            <div className={cn(styles['text-field'])}>
              <label className={styles['text-field-label']}>{t('bank:username')}</label>
              <div className={cn(styles['input-wrapper'])}>
                <input
                  className={cn('form-control')}
                  name="bankUsername"
                  type="text"
                  placeholder="daniel.dicaprio e.p"
                  onChange={handleBankUsername}
                  // maxLength={limitAccountNumber}
                  // minLength={limitAccountNumber}
                />
              </div>
            </div>
          </Col>
          <Col span={24} md={12} className="pad">
            <div className={cn(styles['text-field'])}>
              <label className={styles['text-field-label']}>{t('bank:password')}</label>
              <div className={cn(styles['input-wrapper'])}>
                <div className={styles['suffix-icon-wrapper']}>
                  {passwordFieldType === 'password' ? (
                    <EyeOff onClick={togglePasswordField} />
                  ) : (
                    <Eye onClick={togglePasswordField} />
                  )}
                </div>
                <input
                  name="bankPassword"
                  type={passwordFieldType}
                  // label={t('bank:password')}
                  placeholder={t('bank:password')}
                  // meta={getFieldMeta('bankPassword')}
                  // field={getFieldProps('bankPassword')}
                  onChange={e => {
                    handleBankPassword(e);
                  }}
                  // suffixIcon={
                  //   passwordFieldType === 'password' ? (
                  //     <Eye onClick={togglePasswordField} />
                  //   ) : (
                  //     <EyeOff onClick={togglePasswordField} />
                  //   )
                  // }
                  // maxLength={limitAccountNumber}
                  // minLength={limitAccountNumber}
                />
              </div>
            </div>
          </Col>
          <Col span={24}>
            <div className="centered-text">
              {showMessageErrorAuth && <div className="text-danger">{t('bank:failedLogin')}</div>}
            </div>
          </Col>
        </Row>
      )}

      {showChoiceAccount === true && (
        <>
          <Row gutter={[30, 30]}>
            <Col span={24}>
              <div className="centered-text">
                {showMessageSuccessAuth && <div className="text-success">{t('bank:successLogin')}</div>}
                {showMessageSuccessAuth && <div className="text-success">{t('bank:successMessageNextStep')}</div>}
              </div>
            </Col>
            <Col span={24} md={12} className="pad">
              <CustomTextField
                name="dateOfBirth"
                type="text"
                label={t('bank:dateOfBirth') + ' (YYYY-MM-DD)'}
                placeholder="YYYY-MM-DD"
                meta={getFieldMeta('dateOfBirth')}
                field={getFieldProps('dateOfBirth')}
                onChange={handleChange}
                onInput={formatdateOfBirth}
                inputMode="numeric"
              />
            </Col>
            <Col span={24} md={12} className="pad">
              <CustomTextField
                name="bankAccount"
                type="text"
                label={t('bank:labelAccountNumber')}
                placeholder="xxxxxxxxxx"
                meta={getFieldMeta('bankAccount')}
                field={getFieldProps('bankAccount')}
                onChange={handleChange}
                // maxLength={limitAccountNumber}
                // minLength={limitAccountNumber}
              />
            </Col>
            <Col span={24}>
              <div className="centered-text">
                {showMessageInit && <div className="text-danger">{t('bank:errorDtceAccount')}</div>}
              </div>
            </Col>
          </Row>
        </>
      )}

      <Row className="">
        <Col span={12} offset={9}>
          {showChoiceAccount === false && (
            <Button
              title={t('bank:validate')}
              onClick={verifUserOBDX}
              size="m"
              rounded
              type="button"
              disabled={loading}
              loading={loading}
            />
          )}
        </Col>
        {/* <Col span={24} offset={0}>
          {showChoiceAccount === false && (
            <div className="centered-text">
              {t('bank:notAccount')} &nbsp;
              <a href={process.env.REACT_APP_CREATE_ACCOUNT_URL} target="blank" className="text-success">
                {t('bank:createAccount')}
              </a>
            </div>
          )}
        </Col> */}
        {/* {showChoiceAccount === true && ()} */}
      </Row>
    </div>
  );
};

export default BankPaymentMethodForm;
